export const PRUNE_LOGS_TASK = "pruneLogs";
